export default __webpack_public_path__ + "static/media/toast-warning.5e33440e.svg";